import { clientCopy } from "@/client/copy";

/** `userAgentData` exists only in some engines; `navigator.platform` is the fallback. */
interface PlatformNavigator extends Navigator {
  readonly userAgentData?: { readonly platform?: string };
}

function onAppleKeyboard(): boolean {
  const asked = navigator as PlatformNavigator;
  return /mac|iphone|ipad/i.test(
    asked.userAgentData?.platform ?? asked.platform,
  );
}

export function glyph(modifier: "mod" | "alt" | "shift"): string {
  const keys = onAppleKeyboard()
    ? clientCopy.keyboard.apple
    : clientCopy.keyboard.other;
  return keys[modifier];
}
